import React from 'react';

/**
 * Horizontal line (hr) component
 * @component
 */
export default props => <hr className="Hr" {...props} />;
